import gql from 'graphql-tag';

// Page-Locked Articles: createArticles for one Facebook Page. A separate document, so the page-off path keeps
// sending CREATE_ARTICLES_MUTATION exactly as before.
export const CREATE_PAGE_ARTICLES_MUTATION = gql`
  mutation CreatePageArticles(
    $campaignId: ID!
    $urls: [String!]!
    $manualExpirationTime: String
    $facebookPageId: BigInt!
    $copyCreativesFromOtherPages: Boolean
  ) {
    createArticles(
      campaignId: $campaignId
      urls: $urls
      manualExpirationTime: $manualExpirationTime
      facebookPageId: $facebookPageId
      copyCreativesFromOtherPages: $copyCreativesFromOtherPages
    ) {
      results {
        url
        article {
          id
        }
        error
        existingArticleId
      }
      error
    }
  }
`;
